var _rect, _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuHaas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1480)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_1480)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_1480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.466H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 513.738L368.856 205.431H748.286L-27.857 815.176L-23.587 513.738Z",
    fill: "url(#paint2_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.857 815.176L298.789 558.56H735.272L405.923 817.299L-27.857 815.176Z",
    fill: "url(#paint9_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_3_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_3_1480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.791 250.155C244.777 260.273 233.752 267.166 221.056 267.166C211.701 267.166 203.237 263.386 197 257.382H206.689C206.689 257.382 234.531 208.459 234.643 208.236C234.754 208.014 234.754 207.903 234.531 207.903H223.172C222.949 207.903 222.949 208.014 222.838 208.014C222.726 208.125 207.135 235.255 207.135 235.255H186.643C186.531 234.366 186.531 233.587 186.531 232.698C186.531 213.685 202.012 198.229 221.056 198.229C230.745 198.229 239.543 202.232 245.891 208.792C243.218 213.351 230.967 234.143 229.297 237.145C228.295 234.922 223.951 235.366 221.724 235.366C220.722 237.034 216.155 245.707 216.155 245.707C216.155 245.707 218.717 245.707 221.056 245.707C223.283 245.707 223.506 248.042 222.615 249.487C221.724 250.933 218.049 257.382 218.049 257.382H229.742C229.742 257.382 244.109 232.253 252.35 218.021C253.464 220.356 254.355 222.913 254.912 225.471C257.696 223.58 261.037 222.469 264.712 222.469C259.923 202.677 242.216 188 221.056 188C196.332 188 176.285 208.014 176.285 232.698C176.285 233.587 176.285 234.477 176.397 235.255H170.606C170.271 235.255 170.16 235.478 169.937 235.7C169.826 235.922 164.703 245.04 164.48 245.262C164.369 245.485 164.369 245.596 164.592 245.596H178.179C183.747 263.942 200.787 277.285 221.056 277.285C237.204 277.285 251.237 268.834 259.144 256.048C255.803 255.047 252.907 252.934 250.791 250.155ZM188.981 245.596H200.898L195.107 255.492C192.657 252.601 190.541 249.265 188.981 245.596Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.698 244.817C261.817 244.817 265.381 243.261 268.499 240.481C268.499 240.481 268.053 242.705 267.942 243.372C267.831 244.039 268.276 244.595 268.944 244.595H269.167C269.835 244.595 270.392 244.039 270.504 243.372L271.617 237.145C271.729 236.478 271.283 235.922 270.615 235.922H264.378C263.71 235.922 263.042 236.256 262.93 236.923C262.93 236.923 262.93 237.145 262.93 237.257C262.819 237.924 263.265 238.369 263.933 238.369H267.162L267.051 238.48C264.824 240.592 262.039 241.704 259.812 241.704C257.585 241.704 255.023 240.259 255.023 237.034C255.023 230.363 261.26 226.471 264.601 226.471C259.367 226.471 254.8 229.585 252.684 234.143C252.239 235.478 251.905 236.701 251.905 237.924C251.905 243.928 256.694 244.817 258.698 244.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49 226.583C261.148 226.583 254.912 230.474 254.912 237.145C254.912 240.37 257.473 241.815 259.701 241.815C261.928 241.815 264.712 240.703 266.94 238.591L267.051 238.48H263.821C263.153 238.48 262.708 238.035 262.819 237.368C262.819 237.368 262.819 237.145 262.819 237.034C262.93 236.367 263.599 236.034 264.267 236.034H270.503C271.172 236.034 271.617 236.59 271.506 237.257L270.392 243.483C270.281 244.15 269.835 244.706 269.056 244.706H268.833C268.165 244.706 267.719 244.15 267.831 243.483C267.942 242.816 268.387 240.592 268.387 240.592C265.381 243.372 261.705 244.929 258.587 244.929C256.582 244.929 251.793 244.039 251.793 238.146C251.793 236.923 252.016 235.7 252.573 234.366V234.477C252.462 234.699 252.35 235.033 252.239 235.255C252.128 235.478 252.128 235.589 252.016 235.811C251.905 236.034 251.905 236.367 251.793 236.59C251.793 236.812 251.682 236.923 251.682 237.145C251.571 237.479 251.571 237.701 251.571 238.035C251.571 238.146 251.571 238.369 251.459 238.48C251.459 238.924 251.348 239.369 251.348 239.925C251.348 242.149 251.905 244.262 252.907 246.152C254.132 248.376 255.914 250.266 258.142 251.378C260.035 252.378 262.151 252.934 264.378 252.934C266.606 252.934 268.722 252.378 270.615 251.378C272.842 250.155 274.735 248.376 275.849 246.152C276.852 244.262 277.408 242.149 277.408 239.925C277.631 232.476 271.729 226.583 264.49 226.583Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.227 312.976H103.896C105.566 312.976 106.346 312.198 106.68 310.308L110.244 290.182L113.696 303.636C114.03 304.971 114.253 305.86 116.814 305.86C119.042 305.86 119.487 305.082 120.267 303.859L128.731 289.96L125.167 310.085C124.833 311.975 125.724 312.976 127.283 312.976H127.951C129.622 312.976 130.401 312.087 130.735 310.308L135.19 285.401C135.524 283.4 134.633 282.066 132.517 282.066H130.735C128.954 282.066 128.285 282.622 127.06 284.512L117.483 299.967L113.473 284.623C113.028 282.844 112.471 282.066 110.466 282.066H109.13C107.237 282.066 105.9 283.178 105.566 285.29L101.111 310.196C100.777 311.975 101.557 312.976 103.227 312.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 312.976C153.9 312.976 158.466 306.527 158.244 299.411C158.021 293.407 153.9 288.959 146.995 288.959C139.088 288.959 134.299 295.408 134.522 302.413C134.745 308.862 139.199 312.976 145.77 312.976ZM146.995 293.296C150.448 293.296 153.121 295.964 153.232 299.633C153.343 304.637 150.225 308.529 145.77 308.529C142.095 308.529 139.756 305.86 139.534 302.191C139.422 297.521 142.541 293.296 146.995 293.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.251 312.976H161.919C163.589 312.976 164.257 312.309 164.592 310.308L166.708 298.077C168.267 295.408 169.937 294.074 172.61 294.074C175.283 294.074 176.842 295.631 176.842 298.299C176.842 298.966 176.731 299.856 176.619 300.857L174.949 310.196C174.615 312.309 175.84 312.865 177.288 312.865H177.956C179.626 312.865 180.295 312.198 180.629 310.196L182.411 299.856C182.633 298.744 182.745 297.632 182.745 296.743C182.633 292.295 179.738 289.293 174.838 289.293C171.496 289.293 168.935 290.961 167.264 293.629C167.376 290.516 165.705 289.627 163.923 289.627C163.144 289.627 162.476 289.849 162.364 289.96L158.912 310.308C158.578 312.42 159.803 312.976 161.251 312.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.928 312.976H262.596C264.044 312.976 264.712 312.309 265.046 310.308L266.271 303.525C267.162 298.299 269.167 294.519 272.285 294.519C273.845 294.519 274.735 295.186 275.515 295.853C275.626 295.964 277.965 295.075 277.854 292.184C277.742 290.405 276.072 289.293 273.845 289.293C271.172 289.293 269.167 290.85 267.719 293.629C267.942 290.516 266.16 289.627 264.49 289.627C263.599 289.627 263.042 289.849 262.93 289.96L259.367 310.196C259.032 312.42 260.48 312.976 261.928 312.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.872 312.976C289.436 312.976 292.109 311.531 293.891 308.529C293.668 311.531 294.225 312.531 296.452 312.531C298.457 312.531 299.014 311.864 299.237 309.64C299.459 305.638 300.907 299.078 302.466 289.96C302.466 289.849 301.575 289.293 300.462 289.293C298.234 289.293 297.009 290.405 296.341 293.185C294.893 290.516 291.998 288.959 288.657 288.959C281.529 288.959 276.517 295.297 276.517 302.636C276.406 308.529 280.081 312.976 285.872 312.976ZM289.325 293.296C293.334 293.296 295.116 296.298 295.116 299.522C295.116 303.636 292.332 308.64 287.209 308.64C283.756 308.64 281.64 306.416 281.64 302.524C281.64 297.854 284.313 293.296 289.325 293.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.694 312.976H305.362C306.81 312.976 307.701 312.42 308.035 310.308L310.262 297.743C311.933 295.297 313.38 294.185 315.831 294.185C318.169 294.185 319.617 295.964 319.617 298.633C319.617 299.078 319.617 299.522 319.506 299.967L317.724 310.308C317.39 312.42 318.615 312.976 320.063 312.976H320.619C322.067 312.976 322.958 312.309 323.404 310.308L325.631 297.743C327.302 295.297 328.861 294.185 331.199 294.185C333.427 294.185 335.097 295.52 335.097 298.41C335.097 299.078 334.986 299.967 334.763 300.968L333.093 310.308C332.759 312.42 333.872 312.976 335.432 312.976H336.1C337.77 312.976 338.438 312.309 338.773 310.308L340.554 299.967C340.777 298.855 340.889 297.743 340.889 296.854C340.889 292.295 337.77 289.404 333.427 289.404C329.529 289.404 326.856 291.406 325.074 294.408C324.183 291.294 321.51 289.404 318.058 289.404C315.051 289.404 312.49 290.85 310.708 293.518C310.819 290.627 309.148 289.849 307.367 289.849C306.587 289.849 305.919 290.071 305.807 290.183L302.244 310.419C302.021 312.42 303.246 312.976 304.694 312.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.441 312.976C202.234 312.976 206.132 309.974 206.132 307.528C206.132 305.86 205.019 305.304 203.682 305.193C201.9 307.528 199.45 308.64 195.998 308.64C192.991 308.64 189.427 307.528 189.204 302.191H204.684C206.355 302.191 207.58 301.19 207.58 299.189C207.58 296.075 206.912 293.963 205.464 292.184C203.905 290.182 201.009 288.959 197.78 288.959C187.645 288.959 184.081 296.409 184.081 302.858C184.193 308.862 188.647 312.976 195.441 312.976ZM197.445 293.073C199.227 293.073 200.675 293.629 201.566 294.63C202.346 295.519 202.68 296.854 202.568 298.41H189.761C190.986 295.075 193.882 293.073 197.445 293.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.919 321.871H211.032C213.148 321.871 213.817 320.648 214.819 318.869L229.297 294.519C228.851 296.187 228.629 298.077 228.74 299.856C228.963 308.084 234.531 312.976 242.661 312.976C246.559 312.976 249.566 311.531 251.237 309.307C251.125 311.642 252.35 312.643 254.132 312.643C255.135 312.643 255.803 312.309 255.803 312.198L258.141 299.078C258.476 297.076 257.696 296.075 255.803 296.075H246.559C245.445 296.075 244.889 296.298 244.554 296.631C243.998 297.187 243.775 298.522 243.775 299.189C243.775 300.189 244.666 300.745 246.114 300.745H252.684C251.793 305.304 248.898 308.529 243.886 308.529C238.652 308.529 235.088 305.193 234.865 299.522C234.643 292.406 239.32 286.513 246.114 286.513C250.012 286.513 253.13 288.626 254.355 291.406C254.466 291.628 258.141 291.628 258.03 288.515C258.03 287.403 257.362 286.068 256.137 284.957C254.244 283.066 250.568 281.399 245.78 281.399C238.986 281.399 233.752 285.068 230.967 290.516C230.411 289.849 229.52 289.404 228.629 289.404C227.07 289.404 226.179 289.849 224.731 292.406L217.603 304.971L214.93 292.406C214.374 290.071 213.594 289.404 212.035 289.404C210.253 289.404 208.805 290.627 208.916 290.961L214.039 311.197L208.694 319.87C207.914 320.648 207.914 321.871 209.919 321.871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.376 336.993H103.116V329.432H101V346.889H103.116V338.772H119.376V346.889H121.381V329.432H119.376V336.993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.631 329.432L123.385 346.778H125.835L128.063 342.886H141.984L144.322 346.778H146.773L136.415 329.432H133.631ZM129.176 341.218L135.079 330.989L141.093 341.218H129.176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.135 329.432L148.889 346.889H151.339L153.566 342.997H167.487L169.826 346.889H172.276L161.919 329.543H159.135V329.432ZM154.68 341.218L160.582 330.989L166.596 341.218H154.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87 337.327C187.756 337.215 186.865 337.104 186.309 337.104C185.752 337.104 185.084 337.104 184.415 337.104H180.295H178.401C177.288 337.104 176.397 336.882 175.84 336.548C175.283 336.215 174.949 335.436 174.949 334.324C174.949 333.769 175.06 333.213 175.172 332.768C175.283 332.323 175.729 331.989 176.285 331.767C176.842 331.545 177.733 331.322 178.958 331.211C180.183 331.1 181.408 331.1 182.522 331.1H183.302C184.861 331.1 186.086 331.211 186.977 331.322C187.979 331.434 188.647 331.545 188.981 331.767C189.316 331.989 189.65 332.212 189.761 332.657C189.984 333.101 189.984 333.657 189.984 334.547H192.1C192.1 332.99 191.766 331.767 191.098 330.989C190.429 330.21 189.427 329.766 188.202 329.655C186.977 329.543 185.975 329.432 185.418 329.432C184.861 329.432 183.97 329.432 182.633 329.432C181.074 329.432 179.738 329.432 178.513 329.543C177.288 329.655 176.174 329.877 175.283 330.21C174.392 330.544 173.724 331.1 173.39 331.878C173.056 332.657 172.833 333.657 172.833 334.88C172.833 336.326 173.278 337.438 174.169 338.105C175.06 338.772 176.285 338.994 177.956 338.994L182.633 339.106H186.643C187.979 339.106 188.981 339.328 189.65 339.661C190.207 339.995 190.541 340.773 190.541 342.108C190.541 343.108 190.318 343.775 189.872 344.22C189.427 344.665 188.536 344.999 187.311 345.11C186.086 345.221 184.527 345.332 182.745 345.332C181.631 345.332 180.517 345.332 179.404 345.221C178.29 345.11 177.288 344.999 176.62 344.776C175.951 344.554 175.506 344.22 175.394 343.775C175.283 343.331 175.172 342.664 175.172 341.663V341.329H173.056C173.056 343.22 173.39 344.554 173.947 345.332C174.504 346.11 175.506 346.555 176.842 346.778C178.179 347 179.181 347.111 179.849 347.111C180.517 347.111 181.52 347.111 182.745 347.111H184.081C185.418 347.111 186.643 347.111 187.756 347C188.87 346.889 189.872 346.666 190.652 346.333C191.432 345.999 191.988 345.443 192.323 344.776C192.657 344.109 192.768 343.22 192.768 342.108C192.768 340.551 192.434 339.328 191.766 338.661C190.986 337.882 189.984 337.438 188.87 337.327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.244 346.889H208.36V338.772H222.169V336.993H208.36V331.211H222.838V329.432H206.244V346.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.005 331.211H255.691V346.889H257.807V331.211H266.717V329.432H247.005V331.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.726 338.772H285.316V336.993H270.726V331.211H285.872V329.432H268.61V346.889H285.984V345.11H270.726V338.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.234 329.432L287.988 346.778H290.439L292.666 342.886H306.587L308.926 346.778H311.376L301.019 329.432H298.234ZM293.78 341.218L299.682 330.989L305.696 341.218H293.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.19 344.331L316.833 329.432H313.38V346.889H315.497V331.211L326.299 346.889H327.97L338.884 331.211V346.889H341V329.432H337.659L327.19 344.331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.302 329.432L226.513 332.879L227.626 334.658L231.302 331.989V346.889H233.418V329.432H231.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.093 329.877C236.981 329.766 236.87 329.766 236.759 329.655C236.647 329.655 236.536 329.543 236.313 329.543C236.202 329.543 235.979 329.543 235.868 329.655C235.756 329.655 235.645 329.766 235.534 329.877C235.422 329.988 235.311 330.099 235.311 330.21C235.2 330.322 235.2 330.433 235.2 330.655C235.2 330.766 235.2 330.989 235.311 331.1C235.422 331.211 235.422 331.322 235.534 331.434C235.645 331.545 235.756 331.656 235.868 331.656C235.979 331.656 236.091 331.767 236.313 331.767C236.425 331.767 236.647 331.767 236.759 331.656C236.87 331.656 236.981 331.545 237.093 331.434C237.204 331.322 237.316 331.211 237.316 331.1C237.427 330.989 237.427 330.878 237.427 330.655C237.427 330.544 237.427 330.322 237.316 330.21C237.316 330.099 237.204 329.988 237.093 329.877ZM237.204 330.989C237.204 331.1 237.093 331.211 236.981 331.322C236.87 331.434 236.759 331.434 236.759 331.545C236.647 331.545 236.536 331.656 236.425 331.656C236.313 331.656 236.202 331.656 236.091 331.545C235.979 331.545 235.868 331.434 235.868 331.322C235.756 331.211 235.756 331.1 235.645 330.989C235.645 330.878 235.534 330.766 235.534 330.655C235.534 330.544 235.534 330.433 235.645 330.322C235.645 330.21 235.756 330.099 235.868 329.988C235.979 329.877 236.091 329.877 236.091 329.766C236.202 329.766 236.313 329.655 236.425 329.655C236.536 329.655 236.647 329.655 236.759 329.766C236.87 329.877 236.981 329.877 236.981 329.988C237.093 330.099 237.093 330.21 237.204 330.322C237.316 330.433 237.316 330.544 237.316 330.655C237.316 330.766 237.204 330.878 237.204 330.989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.759 330.655C236.87 330.655 236.87 330.544 236.87 330.433C236.87 330.322 236.87 330.21 236.759 330.21C236.647 330.099 236.536 330.099 236.425 330.099H235.979V331.322H236.202V330.766H236.425L236.759 331.322H236.981L236.647 330.766C236.647 330.766 236.759 330.655 236.759 330.655ZM236.425 330.655H236.202V330.322H236.425H236.536H236.647C236.647 330.322 236.647 330.322 236.759 330.433V330.544V330.655C236.759 330.655 236.759 330.655 236.647 330.766H236.536C236.425 330.544 236.425 330.655 236.425 330.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.601 320.426L215.821 321.871H340.22L341 320.426H216.601Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 321.871H205.019L205.91 320.426H101.78L101 321.871Z",
    fill: "#DA291C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_1480",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_1480",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_1480",
    x1: 64.8378,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_1480",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_1480",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_1480",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_1480",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_1480",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_1480",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_1480",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_1480",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_1480",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_1480",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 159,
    fill: "white",
    transform: "translate(101 188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuHaas);
export default __webpack_public_path__ + "static/media/team_menu_haas.ddbbeac281e3cb29eb851e6f05c4e956.svg";
export { ForwardRef as ReactComponent };